import { Link } from 'react-router-dom'
import './BookAConsult.css'
import { useSiteContent } from '../../../../context/SiteContentContext'
import { field, mediaSrc } from '../../../../utils/cms'

const BookAConsult = () => {
  const { whatsNext } = useSiteContent()
  if (!whatsNext) return null

  const image = mediaSrc(whatsNext, 'background')
  const buttonUrl = field(whatsNext, 'buttonUrl') || '/contact'

  return (
    <section className="whats-next">
      {image ? <img src={image} alt="" className="whats-next__image" /> : null}
      <div className="whats-next__overlay" />
      <div className="whats-next__inner" data-reveal>
        <p className="whats-next__eyebrow">{field(whatsNext, 'eyebrow')}</p>
        <h2 className="whats-next__title">
          {field(whatsNext, 'title')}{' '}
          <span className="whats-next__title-accent">
            {field(whatsNext, 'titleAccent')}
          </span>
        </h2>
        <p className="whats-next__subtitle">{field(whatsNext, 'subtitle')}</p>
        <Link to={buttonUrl} className="whats-next__btn">
          {field(whatsNext, 'buttonText')}
          <span aria-hidden>→</span>
        </Link>
      </div>
    </section>
  )
}

export default BookAConsult
